import { toast, ToastOptions, TypeOptions } from "react-toastify";

type ToastConfig = ToastOptions & {
  position?: ToastOptions['position']; // optional override
};

const defaultConfig: ToastConfig = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showToast = (message: string, type: TypeOptions = "default", config?: ToastConfig) => {
  toast(message, { ...defaultConfig, type, ...config });
};

export const showSuccess = (message: string, config?: ToastConfig) =>
  showToast(message, "success", config);

export const showError = (message: string, config?: ToastConfig) =>
  showToast(message, "error", config);

export const showInfo = (message: string, config?: ToastConfig) =>
  showToast(message, "info", config);

export const showWarning = (message: string, config?: ToastConfig) =>
  showToast(message, "warning", config);